import { render } from "./NewTicketForm.vue?vue&type=template&id=13c7ebd0&scoped=true"
import script from "./NewTicketForm.vue?vue&type=script&lang=js"
export * from "./NewTicketForm.vue?vue&type=script&lang=js"

import "./NewTicketForm.vue?vue&type=style&index=0&id=13c7ebd0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13c7ebd0"
/* hot reload */
if (module.hot) {
  script.__hmrId = "13c7ebd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13c7ebd0', script)) {
    api.reload('13c7ebd0', script)
  }
  
  module.hot.accept("./NewTicketForm.vue?vue&type=template&id=13c7ebd0&scoped=true", () => {
    api.rerender('13c7ebd0', render)
  })

}

script.__file = "src/components/forms/NewTicketForm.vue"

export default script